import React from 'react';
import styled, { css } from 'styled-components';
import Col from 'base/components/Col';
import Card from 'base/components/Card';

const EditorCol = styled(Col)`
  ${(props) => props.isEmpty && css`
    opacity: 0.5;
  `}
  ${(props) => props.isEmpty && props.readOnly && css`
    opacity: 0;
  `}
  p {
    margin: 10px 20px;
  }
`;

function Column({ node, readOnly, ...props }) {
  const widthProps = (node.data && node.data.get('width'))
    ? {
      flexBasis: node.data.get('width'),
      flexGrow: 0,
      flexShrink: 0,
    }
    : {};
  const colContent = node.nodes;
  const isEmpty = colContent && colContent.size === 1
      && colContent.first() && colContent.first().type === 'paragraph'
      && colContent.first().nodes && colContent.first().nodes.size === 1
      && colContent.first().nodes.first().object === 'text'
      && colContent.first().nodes.first().text === '';
  return (
    <EditorCol {...props} {...widthProps} readOnly={readOnly} isEmpty={isEmpty}>
      <Card {...props} flexDirection="column" />
    </EditorCol>
  );
}

export default Column;
